<template>
  <AppButton
    color="grey-6"
    text-color="black"
    class="text-16-400 ctx-menu-btn border-radius-10"
    padding="8px 15px"
    icon-left-size="16px"
    label-class="q-pl-sm"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  />
</template>

<script>
import AppButton from 'common/components/buttons/AppButton';

export default {
  name: 'ContextMenuButton',
  components: { AppButton },
};
</script>

<style lang="scss">
.ctx-menu-btn {
  div {
    transition: all 0.25s ease;
  }
  &:hover {
    div {
      color: #FFF !important;
    }
  }
  .q-focus-helper {
    opacity: 0 !important;
  }
}
</style>
